module.exports = {"foo":"hahahahah EN","hello":"{{name}} <b>hi!</b>"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = NuBg
// module chunks = 1